import React, { useState } from "react";
import { Modal } from "antd";
import image01 from "../../assets/images/Ellipse 1.png";
import image02 from "../../assets/images/i m student.png";
// import image03 from "../../assets/images/Facebook.png";
import { toast } from "react-toastify";
import { googleSignUp, signIn, forgotpassword } from "../../services/auth";
import {
  AUTH_TOKEN,
  SEARCH_URL,
  STUDENT_HOME_URL,
  STUDENT_ROLE,
  STUENT_JOURNEY_URL,
  TEACHER_JOURNEY_URL,
  TEACHER_ROLE,
} from "../../constants";
import Loader from "../loader";
import { useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { useDispatch } from "react-redux";
import { setUser } from "../../redux/slice/auth/authSlice";
import jwt_decode from "jwt-decode";
import "./styles.css";
import { fetchTeacherDocuments } from "../../services/teacher";
import { GoEyeClosed } from "react-icons/go";
import { FiEye } from "react-icons/fi";
import { saveAuthToken } from "../../helper/utils";

const INITIAL_STATE = {
  email: "",
  password: "",
  role: "",
};

const SignIn = ({ openLogIn, handleLogInModal }) => {
  // const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [isTeacher, setIsTeacher] = useState(true);
  const [openSignUpModal, setOpenSignUpModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [forgotLoading, setForgotLoading] = useState(false);
  const [formData, setFormData] = useState({ ...INITIAL_STATE });
  const [showPassword, setShowPassword] = useState(false);
  const [forgotPasswordModal, setForgotPasswordModal] = useState(false);
  const [forgotPasswordData, setForgotPasswordData] = useState({
    email: "",
    newPassword: "",
    confirmPassword: "",
    role: isTeacher ? TEACHER_ROLE : STUDENT_ROLE,
  });

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSelection = () => {
    setIsTeacher(!isTeacher);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleForgotPasswordChange = (e) => {
    const { name, value } = e.target;
    setForgotPasswordData({
      ...forgotPasswordData,
      [name]: value,
    });
  };

  const handleRoleChange = (e) => {
    setForgotPasswordData({
      ...forgotPasswordData,
      role: e.target.value,
    });
  };

  const handleForgotPasswordSubmit = async () => {
    if (forgotPasswordData.newPassword !== forgotPasswordData.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    try {
      setForgotLoading(true);
      const payload = {
        email: forgotPasswordData.email,
        password: forgotPasswordData.newPassword,
        role: forgotPasswordData.role,
      };
      const response = await forgotpassword(payload);
      if (response.status === 200) {
        toast.success("Password reset successful");
        setForgotPasswordModal(false);
      } else {
        toast.error(response.data.message || "Failed to reset password");
      }
    } catch (error) {
      toast.error("An error occurred while resetting password");
    } finally {
      setForgotLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      let payload = {
        ...formData,
        role: isTeacher ? TEACHER_ROLE : STUDENT_ROLE,
      };
      const { status, data } = await signIn(payload);
      let token = data?.data;
      const user = token ? jwt_decode(token) : null;

      if (!user) {
        toast.error(data?.message || "Invalid response from server");
        return;
      }

      if (status === 200 && !user.isBlocked) {
        handleLogInModal(false);
        setFormData({ ...INITIAL_STATE });
        // window.location.reload();
        // window.history.push(HOME_URL);
        // localStorage.setItem(AUTH_TOKEN, data.data);
        saveAuthToken(token);
        // Save profile picture URL in localStorage
        if (user?.profilePicture) {
          localStorage.setItem("profilePicture", user.profilePicture);
        } else {
          // Optionally clear if not present
          localStorage.removeItem("profilePicture");
        }
        // login(data.data, user);
        dispatch(setUser(user));
        navigate(
          user?.role === TEACHER_ROLE ? TEACHER_JOURNEY_URL : SEARCH_URL
        );
        toast.success(data?.message || "Login successful");
        return;
      }

      if (user?.isBlocked) {
        toast.error("Your account is blocked by Platform");
        return;
      }

      // ❌ Wrong credentials or other server error
      toast.error(data?.message || "Login failed");
    } catch (error) {
      console.error("Login error:", error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "An unexpected error occurred"
      );
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async (res) => {
      try {
        let payload = {
          token: res?.access_token,
          role: isTeacher ? TEACHER_ROLE : STUDENT_ROLE,
        };
        const { status, data } = await googleSignUp(payload);
        if (status === 201) {
          handleLogInModal(false);
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.log(error);
      }
    },
    onError: (res) => {
      console.log("error", res);
    },
  });

  // const facebookLogin = (response) => {
  //   console.log(response);
  // };

  return (
    <>
      {/* Button Code Start */}
      <div className="d-md-block text-center py-4">
        <button
          onClick={() => handleSelection()}
          className={`btn mb-3 mx-4 shadow-sm px-5 poppins ${
            isTeacher ? "btn-primary primary_bg_color" : ""
          }`}
          type="button"
        >
          <img
            className="signUpTeacher mx-2"
            src={image01}
            alt="Icon"
            width="28px"
          />{" "}
          I'm Teacher
        </button>
        <button
          onClick={() => handleSelection()}
          className={`btn poppins ${
            !isTeacher ? "btn-primary primary_bg_color" : ""
          } shadow-sm mb-3 px-5`}
          type="button"
        >
          <img
            className="signUpStudent mx-2"
            src={image02}
            alt="Icon"
            width="28px"
          />{" "}
          I'm Student
        </button>
      </div>
      {/* Button Code Ends */}

      {/* Form Code Start */}
      <div className="teacherSignUp">
        <h4 className="fw-bold text-center" style={{ fontFamily: "poppins" }}>
          Hey, {isTeacher ? "Teacher" : "Student"}
        </h4>
        <p className="signUp text-center fs_12 poppins">
          Enter the information you entered while registering
        </p>
        <form onSubmit={handleSubmit} className="mx-auto col-md-7 col-sm-6">
          <div className="mb-3">
            <label
              htmlFor="exampleInputEmail1"
              className="form-label fs_12 fw-bold poppins"
            >
              Email address *
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              aria-describedby="emailHelp"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-3">
            <label
              htmlFor="password"
              className="form-labe fs_12l fw-bold poppins"
            >
              Password *
            </label>
            <div className="d-flex position-relative">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />

              <span className="password-toggle position-absolute">
                {showPassword ? (
                  <FiEye onClick={toggleShowPassword} />
                ) : (
                  <GoEyeClosed onClick={toggleShowPassword} />
                )}
              </span>
            </div>
            {/* <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={toggleShowPassword}
            >
              {showPassword ? "Hide" : "Show"}
            </button> */}
          </div>
          <div className="mb-3 form-check">
            {/* <input
                type="checkbox"
                className="form-check-input my-1"
                id="exampleCheck1"
              /> */}
            <div className="d-flex justify-content-end ">
              {/* <label
                  className="form-check-label fs_12 my-1"
                  htmlFor="exampleCheck1"
                >
                  Remember me
                </label> */}
              <span
                className="forgotpassword fs_12 my-1 link-dark text-decoration-none cursor_pointer"
                onClick={() => {
                  setForgotPasswordModal(true);
                  setForgotPasswordData((prev) => ({
                    ...prev,
                    role: isTeacher ? TEACHER_ROLE : STUDENT_ROLE,
                  }));
                }}
              >
                Forgot your password?
              </span>
            </div>
          </div>
          <button
            disabled={loading}
            type="submit"
            className="btn btn-primary btn_contained d-grid gap-2 col-12 p-2"
          >
            {loading ? <Loader /> : "Login"}
          </button>
          {/* Form Code Ends */}
          {/* Social Buttons Start */}
          {/* <GoogleLogin
              onSuccess={(credentialResponse) => {
                console.log(credentialResponse);
              }}
              onError={() => {
                console.log("Login Failed");
              }}
            /> */}
          {/* <p className="signInWith mt-4 text-center fs_12">
              {" "}
              <span className="dashed">---</span> Or Sign In With{" "}
              <span className="dashed">---</span>
            </p>

            <div className="d-md-block text-center ">
              <button
                onClick={() => googleLogin()}
                className="btn mx-4 btn-light shadow-sm px-4"
                type="button"
              >
                <img
                  className="mx-2 mb-1"
                  src={image04}
                  alt="google"
                  width="16px"
                />
                Google
              </button>
                </div> */}
          {/* <ImGoogle /> */}
          {/* <FacebookLogin
                appId="1088597931155576"
                // autoLoad
                // fields="name,email,picture"
                // scope="public_profile,user_friends,user_actions.books"
                callback={facebookLogin}
                render={(renderProps) => (
                  <button
                    onClick={renderProps.onClick}
                    className="btn mb-3 btn-light shadow px-4"
                    type="button"
                  >
                    <img
                      className="mx-2 mb-1"
                      src={image03}
                      alt="facebok"
                      width="16px"
                    />
                    Facebook
                  </button>
                )}
              /> */}
          {/* Social Buttons Ends */}
          {/* <div className="signUpText mt-3 text-center fs_12">
              <p>
                Don't have an account yet?{" "}
                <span
                  onClick={() => handleOpenSignUpModal()}
                  className="link-dark text-decoration-none fw-bold cursor_pointer"
                >
                  Sign Up
                </span>
              </p>
            </div> */}
        </form>
      </div>

      {/* Forgot Password Modal - Styled like Login Form */}
      <Modal
        title={
          <h4
            className="fw-bold text-center mb-0"
            style={{ fontFamily: "poppins" }}
          >
            Reset Your Password
          </h4>
        }
        open={forgotPasswordModal}
        onCancel={() => {
          setForgotPasswordModal(false);
          setForgotPasswordData({
            email: "",
            newPassword: "",
            confirmPassword: "",
            role: isTeacher ? TEACHER_ROLE : STUDENT_ROLE,
          });
        }}
        footer={null}
        centered
        width={500}
      >
        <div className="teacherSignUp">
          <p className="text-center fs_12 poppins text-muted">
            Enter your email and new password to reset
          </p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleForgotPasswordSubmit();
            }}
            className="mx-auto"
          >
            <div className="mb-3">
              <label
                htmlFor="forgotEmail"
                className="form-label fs_12 fw-bold poppins"
              >
                Email address *
              </label>
              <input
                type="email"
                className="form-control"
                id="forgotEmail"
                name="email"
                value={forgotPasswordData.email}
                onChange={handleForgotPasswordChange}
                placeholder="Enter your email"
                required
              />
            </div>

            <div className="mb-3">
              <label
                htmlFor="newPassword"
                className="form-label fs_12 fw-bold poppins"
              >
                New Password *
              </label>
              <div className="position-relative">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  id="newPassword"
                  name="newPassword"
                  value={forgotPasswordData.newPassword}
                  onChange={handleForgotPasswordChange}
                  placeholder="Enter new password"
                  required
                />
                <span
                  className="password-toggle position-absolute end-0 top-50 translate-middle-y pe-3"
                  style={{ cursor: "pointer", zIndex: 10 }}
                  onClick={toggleShowPassword}
                >
                  {showPassword ? (
                    <FiEye size={20} />
                  ) : (
                    <GoEyeClosed size={20} />
                  )}
                </span>
              </div>
            </div>

            <div className="mb-3">
              <label
                htmlFor="role"
                className="form-label fs_12 fw-bold poppins"
              >
                Role *
              </label>
              <div className="d-flex">
                <div className="form-check me-3">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="role"
                    value="teacher"
                    checked={forgotPasswordData.role === "teacher"}
                    onChange={handleRoleChange}
                  />
                  <label className="form-check-label">Teacher</label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="role"
                    value="student"
                    checked={forgotPasswordData.role === "student"}
                    onChange={handleRoleChange}
                  />
                  <label className="form-check-label">Student</label>
                </div>
              </div>
            </div>

            <div className="mb-4">
              <label
                htmlFor="confirmPassword"
                className="form-label fs_12 fw-bold poppins"
              >
                Confirm Password *
              </label>
              <div className="position-relative">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={forgotPasswordData.confirmPassword}
                  onChange={handleForgotPasswordChange}
                  placeholder="Confirm new password"
                  required
                />
                <span
                  className="password-toggle position-absolute end-0 top-50 translate-middle-y pe-3"
                  style={{ cursor: "pointer", zIndex: 10 }}
                  onClick={toggleShowPassword}
                >
                  {showPassword ? (
                    <FiEye size={20} />
                  ) : (
                    <GoEyeClosed size={20} />
                  )}
                </span>
              </div>
            </div>

            <button
              disabled={forgotLoading}
              type="submit"
              className="btn btn-primary btn_contained d-grid gap-2 col-12 p-2"
            >
              {forgotLoading ? <Loader /> : "Reset Password"}
            </button>

            <div className="text-center mt-3">
              <span
                className="text-muted fs_12 cursor_pointer"
                onClick={() => setForgotPasswordModal(false)}
              >
                Back to Login
              </span>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default SignIn;
